import { render, staticRenderFns } from "./BulletinBoard.vue?vue&type=template&id=63d9946e&scoped=true"
import script from "./BulletinBoard.vue?vue&type=script&lang=js"
export * from "./BulletinBoard.vue?vue&type=script&lang=js"
import style0 from "./BulletinBoard.vue?vue&type=style&index=0&id=63d9946e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d9946e",
  null
  
)

export default component.exports